import * as React from 'react';
import Area from '../../../../domain/entities/Area';
import ExploreArea from '../../../../domain/entities/ExploreArea';
import ExploreStation from '../../../../domain/entities/ExploreStation';
import Station from '../../../../domain/entities/Station';
import Icon from '../../../common/icons/Icon';
import css from './ExploreSuggestAreas.module.scss';

interface Props {
  exAreas: ExploreArea[];
  exStations: ExploreStation[];
  heading: string;
  handleClick: (entity: Area | Station) => void;
  handleInput: (query: string) => void;
}

class ExploreSuggestAreas extends React.PureComponent<Props> {
  public static defaultProps: Props = {
    exAreas: [],
    exStations: [],
    heading: '',
    handleClick: (_: Area | Station) => undefined,
    handleInput: (_: string) => undefined,
  };

  constructor(props: Props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleInput = this.handleInput.bind(this);
  }

  private handleClick(
    ev: React.MouseEvent,
    entity: ExploreArea | ExploreStation,
  ) {
    ev.preventDefault();

    if ('area' in entity) {
      this.props.handleClick(entity.area);
    }

    if ('station' in entity) {
      this.props.handleClick(entity.station);
    }
  }

  private handleInput(query: string) {
    this.props.handleInput(query);
  }

  public render() {
    return (
      <div className={css.ExploreSuggestAreas}>
        <div className={css.ExploreSuggestAreas__InputWrap}>
          <input
            className={css.ExploreSuggestAreas__Input}
            onInput={e => {
              this.handleInput(e.currentTarget.value);
            }}
            placeholder={'エリアを入力'}
          />
        </div>

        {this.props.heading && (
          <div className={css.ExploreSuggestAreas__Heading}>
            {this.props.heading}
          </div>
        )}

        <ul className={css.ExploreSuggestAreas__List}>
          {this.props.exAreas.map(ex => {
            return (
              <li key={ex.area.id} className={css.ExploreSuggestAreas__Item}>
                <a href="" onClick={ev => this.handleClick(ev, ex)}>
                  <span className={css.ExploreSuggestAreas__Icon}>
                    <Icon name="area-pin" />
                  </span>
                  <span className={css.ExploreSuggestAreas__LinkText}>
                    {`${ex.area.localName} (${ex.merchantCount})`}
                  </span>
                </a>
              </li>
            );
          })}
          {this.props.exStations.map((ex, i) => {
            return (
              <li key={i} className={css.ExploreSuggestAreas__Item}>
                <a href="" onClick={ev => this.handleClick(ev, ex)}>
                  <span className={css.ExploreSuggestAreas__Icon}>
                    <Icon name="area-station" />
                  </span>
                  <span className={css.ExploreSuggestAreas__LinkText}>
                    {`${ex.station.name} ${ex.station.line.name} (${ex.merchantCount})`}
                  </span>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

export default ExploreSuggestAreas;
